import { render, staticRenderFns } from "./RelevanceStudent.vue?vue&type=template&id=550a217c&scoped=true&lang=html&"
import script from "./RelevanceStudent.vue?vue&type=script&lang=js&"
export * from "./RelevanceStudent.vue?vue&type=script&lang=js&"
import style0 from "./RelevanceStudent.vue?vue&type=style&index=0&id=550a217c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550a217c",
  null
  
)

export default component.exports